import { render, staticRenderFns } from "./CustomMetadataInfo.vue?vue&type=template&id=2a7ec49a&scoped=true"
import script from "./CustomMetadataInfo.vue?vue&type=script&lang=js"
export * from "./CustomMetadataInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomMetadataInfo.vue?vue&type=style&index=0&id=2a7ec49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ec49a",
  null
  
)

export default component.exports